import React, { useState } from 'react';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../../utils/Button';
import FocusControl from '../../../../../utils/FocusControl';
import InputField, {
    SelectOption,
    TextareaField,
    addOption
} from '../../../../../utils/InputField';
import { ApiUpdateService } from '../../ServiceOperation';

function EditServiceModal({ data, handleReload, closeModal }) {
    const { id, serviceTitle, description, status } = data;
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const { setMessage } = useTemplate();

    const [formData, setFormData] = useState({
        Id: id || 0,
        ServiceTitle: serviceTitle || '',
        Description: description || '',
        Status: status || ''
    });

    const isServiceInactive = status !== 'active';

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: value }));
        }
    };

    const handleEditCustomer = (e) => {
        setLoading(true);
        e.preventDefault();
        ApiUpdateService(id, formData, setIsError)
            .then(({ title }) => {
                setMessage({ type: 'success', text: title });
                closeModal();
                handleReload();
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error.toString(0) });
            });
    };

    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleEditCustomer} className="flex flex-col gap-4">
            <InputField
                label="Service Title"
                name="ServiceTitle"
                formData={formData}
                onChange={handleChange}
                disabled={isServiceInactive}
            />
            <TextareaField
                label="Description"
                name="Description"
                formData={formData}
                onChange={handleChange}
                disabled={isServiceInactive}
                height="h-32"
            />

            <SelectOption
                label="Status"
                name="Status"
                formData={formData}
                onChange={handleChange}
                options={['Active', 'Inactive'].map((d) => addOption(d, d, d.toLowerCase()))}
            />
            <div className="w-full flex justify-end items-center gap-2 mb-2">
                <ButtonCancel title="Cancel" onClick={() => closeModal()} />
                <ButtonPrimary title="Save" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default EditServiceModal;
